export * from "modules/DealerDetails/components/DealerDetailsActions/hooks/useDeleteDealerMutation";
